import '../styles/register.css'
import '../styles/progressBar.css'
import maskLogo from '../eye-mask-carnival.svg'
import { ReactNode, useEffect, useState } from 'react';
import { set } from 'mobx';
import RegistrationStore from '../stores/RegistrationStore';
import { Observer, observer } from 'mobx-react-lite';
import { RecorderStore } from '../stores/RecorderStore';
import AudioComp from '../components/AudioComp';
import { reportObserved } from 'mobx/dist/internal';
import { RecorderType } from '../models/app/RecorderType';
import { useHistory } from 'react-router';
import { StyledHeader } from '../components/StyledHeader';
import { RegInvite } from '../components/RegInvite';
import { AppContact } from '../components/AppContact';
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";
import { Transitions } from "../transitions/pageTransitions";

function AnonymRegistration(props: { regStore: RegistrationStore, recorderStore: RecorderStore }) {



    return (<div className='flex-column' style={{ marginBottom: 10 }} >
        {/* <label htmlFor="" >Username</label> */}
        <input className='input-field' type="text" name="" id="" placeholder='Username' maxLength={10}
            onChange={(event) => {
                props.regStore.setUserName(event.target.value)
            }} />
        {/* <label htmlFor="" style={{ marginTop: 10 }}>Password</label> */}
        <input className='input-field' type="password" name="" id="" placeholder='Password' maxLength={20}
            style={{ marginTop: 10 }}
            onChange={(event) => {
                props.regStore.setPassword(event.target.value)
            }} />
        {/* <label htmlFor="" style={{ marginTop: 10 }}>Confirm Password</label> */}
        <div className='flex-row center-align '>
            <input className='input-field' type="password" name="" id="" placeholder='Confirm Password' maxLength={20}
                style={{ marginTop: 10 }}
                onChange={(event) => {
                    props.regStore.setConfirmPassword(event.target.value)
                }}
            />
            <Observer>{() => {

                if (props.regStore.password != '') {
                    if (props.regStore.password == props.regStore.confirmPassword)
                        return <span className="material-icons" style={{ color: 'green' }}>task_alt</span>
                    else
                        return <span className="material-icons" style={{ color: 'red' }}>error</span>
                }
                else
                    return <p>{props.regStore.password}</p>
            }}</Observer>
        </div>
        <label htmlFor="" style={{ marginTop: 10 }} >Your Gender</label>
        <form className='flex-row' >
            <input type="radio" name="sex" id="" value='F' checked onChange={() => props.regStore.setSex('F')} />
            <label htmlFor="">Female</label>
            <input type="radio" name="sex" id="" value='M' onChange={() => props.regStore.setSex('M')} />
            <label htmlFor="">Male</label>

        </form>
        {/* <AudioComp recorderStore={props.recorderStore} /> */}
        {/* <p style={{textAlign: 'center'}} >Please add your Voice Intro</p> */}
    </div>);
}



const SignupComponent = observer((props: { regStore: RegistrationStore, recorderStore: RecorderStore }) => {

    const history = useHistory()

    function getStatus(): ReactNode {

        var x = props.regStore.userName
        x = props.regStore.password
        x = props.regStore.confirmPassword
        x = props.regStore.regProgress
        var y = props.recorderStore.recordTimer


        switch (props.regStore.regProgress) {

            case 'INIT': return 'Register'
                break;
            case 'LOADING': return <progress className="pure-material-progress-circular" />
                break;
            case 'FAILED': return 'Failed'
                break;
            case 'SUCCESS':
                history.replace('/stapp/profile')
                return <span className="material-icons" style={{ color: 'green' }}>task_alt</span>
                break;
        }
    }

    function checkDisabled(): boolean {

        if (props.regStore.regProgress == 'SUCCESS' || props.regStore.userName == '' ||
            props.regStore.password != props.regStore.confirmPassword || props.regStore.password == '' || props.regStore.inviteProg != 'SUCCESS')
            return true
        else return false

    }

    return (
        <button className='button-5 button-fixed '
            onClick={() => props.regStore.registerAnonymously()}
            disabled={checkDisabled()}
        >{getStatus()}</button>);
})


export const Register = () => {

    const regStore = new RegistrationStore()
    const recorderStore = new RecorderStore(RecorderType.INTRO)

    useEffect(() => {
        document.title = 'Register'
    }, [])

    const [state, setState] = useState(0)

    return (
        <motion.div className='flex-column main-cont register absolute ' style={{ height: window.innerHeight, width: '100%' }}
            initial="initial"
            animate="in"
            exit="out"
            variants={Transitions.pageVariants}
            transition={Transitions.pageTransition}
        >
            <div style={{ position: 'absolute', top: 20, left: 20 }} >
                <StyledHeader heading='Register' />
            </div>
            {/* <div className='flex-column logo-header'>
                <p style={{ fontWeight: 700, }}>Register</p>
                <img src={maskLogo} alt="" style={{ height: 120, width: 120 }} />
            </div> */}
            <div className='container center-align  card' style={{ padding: 28 }} >
                <AnonymRegistration regStore={regStore} recorderStore={recorderStore} />
                <RegInvite store={regStore} />
                <div style={{ height: 40 }} />
                <SignupComponent regStore={regStore} recorderStore={recorderStore} ></SignupComponent>
            </div>
            <AppContact />
            <div className='flex-column center-align' style={{ position: 'absolute', bottom: 10 }} >
                <h4>Already got your mask?</h4>
                <Link to='/stapp/login' >
                    <p style={{ color: 'purple', fontWeight: 700 }} >Sign In</p>
                </Link>
            </div>
        </motion.div>
    )
}


